import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Select as AntSelect } from 'antd';
import { ATIVIDADES_OPTIONS } from '../../constants/atividades';
import { ClienteFormValues } from '../ClienteFormSchema';
import { PipelineFieldRow, PIPELINE_INPUT_CLASS } from '@/components/form/pipelineFieldRow';
import { usePipelineForm } from '@/components/form/PipelineFormContext';
import { cn } from '@/lib/utils';

interface AtividadeSelectProps {
  form: UseFormReturn<ClienteFormValues>;
  name: string;
  label: string;
  required?: boolean;
}

export function AtividadeSelect({
  form,
  name,
  label,
  required = false,
}: AtividadeSelectProps) {
  const { isPipeline } = usePipelineForm();

  return (
    <FormField
      control={form.control}
      name={name as keyof ClienteFormValues}
      rules={{
        required: required ? `${label} é obrigatório` : false,
      }}
      render={({ field }) => {
        const errorMessage = form.formState.errors[name]?.message as string | undefined;

        if (isPipeline) {
          return (
            <FormItem className="flex flex-col p-0 space-y-0">
              <PipelineFieldRow label={label} required={required} error={errorMessage}>
                <AntSelect
                  value={(field.value as string) || undefined}
                  placeholder="Selecione a atividade"
                  onChange={(value) => field.onChange(value)}
                  options={ATIVIDADES_OPTIONS.map((option) => ({
                    value: option.value,
                    label: option.label,
                  }))}
                  variant="borderless"
                  className={cn(PIPELINE_INPUT_CLASS, 'w-full')}
                  showSearch
                  optionFilterProp="label"
                  status={errorMessage ? 'error' : undefined}
                  allowClear
                />
              </PipelineFieldRow>
              <FormMessage className="px-3 pb-1" />
            </FormItem>
          );
        }

        return (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              {label}
              {required && <span className="text-destructive">*</span>}
            </FormLabel>
            <Select onValueChange={field.onChange} value={(field.value as string) || ''}>
              <FormControl>
                <SelectTrigger className="h-10">
                  <SelectValue placeholder="Selecione a atividade desenvolvida" />
                </SelectTrigger>
              </FormControl>
              <SelectContent className="max-h-[300px]">
                {ATIVIDADES_OPTIONS.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
}
